import { render, staticRenderFns } from "./SupplierListItem.vue?vue&type=template&id=4719d1b8&scoped=true&"
import script from "./SupplierListItem.vue?vue&type=script&lang=js&"
export * from "./SupplierListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4719d1b8",
  null
  
)

export default component.exports